<template>
    <transition name="fade">
        <div class="tp-wrapper" v-show="this.showPreview">
            <img class="tp-url" :src="this.url" alt="">
            <p class="tp-name">{{$t(this.situationName)}}</p>
        </div>
    </transition>
</template>

<style>
    .tp-wrapper{
        pointer-events: none;
        position: absolute;
        text-align: center;
        bottom: 10%;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column
    }
    .tp-url{
        margin-top: 10px;
        width: 380px !important;
        height: 240px !important;
        object-fit: cover;
    }
    .tp-name{
        color: white; 
        font-size: 20px;
        font-size: 30px;
        margin-bottom: 15px;
        margin-top: 15px;
    }
</style>
    
<script>
export default {
    name: 'transitionPreview',
    data: () => ({
        showPreview: false,
        url: null,
        situationName: null,
	}),
	methods: {
        hideTransitionPreview(){
            this.showPreview = false;
        },
        showTransitionPreview: function(e) {
            this.url = e.detail.url;
            this.situationName = e.detail.name;
            this.showPreview = true;
        }
    },
    mounted: function(){
        window.addEventListener('hideTransitionPreview',this.hideTransitionPreview);
        window.addEventListener('showTransitionPreview',this.showTransitionPreview);
    }
}

</script>